import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 23 12",
  "content": "<symbol viewBox=\"0 0 23 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-right\">\r\n<path d=\"M22.1303 6.53033C22.4232 6.23744 22.4232 5.76256 22.1303 5.46967L17.3574 0.696699C17.0645 0.403806 16.5896 0.403806 16.2967 0.696699C16.0038 0.989593 16.0038 1.46447 16.2967 1.75736L20.5393 6L16.2967 10.2426C16.0038 10.5355 16.0038 11.0104 16.2967 11.3033C16.5896 11.5962 17.0645 11.5962 17.3574 11.3033L22.1303 6.53033ZM0 6.75H21.6V5.25H0V6.75Z\" fill=\"#208FFD\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol